<div class="form-builder-option">
  <div class="form-builder-option-fields">
    <div class="form-builder-option-fields-wrapper">
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label">
            <span translationEditableDirective="LABEL">{{
              'LABEL' | translate
            }}</span
            >:
          </label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <input
                class="input is-small"
                name="label"
                (input)="handleFieldChange({ e: $event })"
                type="text"
                [value]="option.get('label')"
              />
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label">
            <span translationEditableDirective="VALUE">{{
              'VALUE' | translate
            }}</span
            >:
          </label>
        </div>
        <div class="field-body" style="width: 60px">
          <div class="field">
            <p class="control">
              <input
                class="input is-small"
                name="value"
                [value]="option.get('value')"
                (input)="handleFieldChange({ e: $event })"
                type="text"
                *ngIf="!isPropertyType"
              />

              <number-input
                *ngIf="isPropertyType"
                name="value"
                (input)="handleFieldChange({ e: $event })"
                [value]="option.get('value')"
                step="0.01"
                inputClass="input is-small"
              />
            </p>
          </div>
        </div>
      </div>
      <div
        *ngIf="option.get('rate') !== undefined && isPropertyType"
        class="field is-horizontal"
      >
        <div class="field-label is-small">
          <label class="label">
            <span translationEditableDirective="RATE">{{
              'RATE' | translate
            }}</span
            >:
          </label>
        </div>
        <div class="field-body" style="width: 60px">
          <div class="field">
            <p class="control">
              <number-input
                name="rate"
                (input)="handleFieldChange({ e: $event })"
                [value]="option.get('rate')"
                step="0.01"
                inputClass="input is-small"
              />
            </p>
          </div>
        </div>
      </div>
      <div
        *ngIf="option.get('rate') !== undefined && isPropertyType"
        class="field is-horizontal"
      >
        <div class="field-label is-small">
          <label class="label">
            <span translationEditableDirective="PENTALTY">{{
              'PENTALTY' | translate
            }}</span>
            %:
          </label>
        </div>
        <div class="field-body" style="width: 60px">
          <div class="field">
            <p class="control">
              <number-input
                inputClass="input is-small"
                name="penaltyPercentage"
                (input)="handleFieldChange({ e: $event })"
                [value]="option.get('penaltyPercentage')"
                step="0.01"
              />
            </p>
          </div>
        </div>
      </div>
      <div
        *ngIf="option.get('rate') !== undefined && isPropertyType"
        class="field is-horizontal"
      >
        <div class="field-label is-small">
          <label class="label">
            <span translationEditableDirective="MIN_TAX">{{
              'MIN_TAX' | translate
            }}</span
            >:
          </label>
        </div>
        <div class="field-body" style="width: 60px">
          <div class="field">
            <p class="control">
              <number-input
                inputClass="input is-small"
                name="minTax"
                (input)="handleFieldChange({ e: $event })"
                [value]="option.get('minTax')"
                step="0.01"
              />
            </p>
          </div>
        </div>
      </div>
      <div
        *ngIf="option.get('rate') !== undefined && isPropertyType"
        class="field is-horizontal"
      >
        <div class="field-label is-small">
          <label class="label">
            <span translationEditableDirective="MAX_TAX">{{
              'MAX_TAX' | translate
            }}</span
            >:
          </label>
        </div>
        <div class="field-body" style="width: 60px">
          <div class="field">
            <p class="control">
              <number-input
                inputClass="input is-small"
                name="maxTax"
                (input)="handleFieldChange({ e: $event })"
                [value]="option.get('maxTax') ?? ''"
                step="0.01"
              />
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="form-builder-option-buttons buttons">
      <div class="arrow-buttons">
        <button
          class="button is-small"
          (click)="
            handleOptionsOrderChange({ option: option, direction: 'up' })
          "
          type="button"
        >
          <i class="fas fa-angle-up"></i>
        </button>
        <button
          class="button is-small"
          (click)="
            handleOptionsOrderChange({ option: option, direction: 'down' })
          "
          type="button"
        >
          <i class="fas fa-angle-down"></i>
        </button>
      </div>
      <button
        type="button"
        class="button is-small is-info"
        (click)="addInput()"
        translationEditableDirective="ADD_INPUT"
      >
        {{ 'ADD_INPUT' | translate }}
      </button>
      <button
        type="button"
        class="button is-small is-info"
        (click)="addSelect()"
        translationEditableDirective="ADD_SELECT"
      >
        {{ 'ADD_SELECT' | translate }}
      </button>
      <button
        type="button"
        class="button is-small is-danger"
        (click)="deleteOption()"
      >
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
  </div>

  <app-form-builder-row
    [row]="child"
    [isPropertyType]="child.get('isPropertyType')"
    *ngFor="let child of option.get('children'); let index = index"
    [index]="index"
    (onAddInput)="addInput($event)"
    (onAddOption)="addOption($event)"
    (onAddSelect)="addSelect($event)"
    (onDeleteRow)="deleteRow($event)"
    (onDeleteOption)="deleteOption($event)"
    (onChangeField)="handleFieldChange($event)"
    (onChangeOptionsOrder)="handleOptionsOrderChange($event)"
  ></app-form-builder-row>
</div>
